module.exports = __webpack_public_path__ + "img/youngman.3d146432.png";